<template>
  <div ref="dom" class="charts chart-pie"></div>
</template>

<script>
import * as echarts from "echarts";
// import "echarts-liquidfill";
import { on, off } from "@/libs/tools";
export default {
  name: "ChartBar",
  props: {
    value: Array,
    text: String,
    subtext: String,
    colorList: Array,
    color: String,
  },
  data() {
    return {
      dom: null,
    };
  },
  watch: {
    value: {
      handler(newVal) {
        // console.log(newVal);
        this.loadEcharts(newVal);
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    resize() {
      this.dom.resize();
    },
    loadEcharts(val) {
      this.$nextTick(() => {
        let option = {
          color: [
            "#02C622",
            "#7C5BF6",
            "#F9FF57",
            "#FF893B",
            "#8DFD15",
            "#00FFFF",
          ],
          legend: {
            // width: "65%",
            left: "center",
            textStyle: {
              color: "#666",
              fontSize: 12,
            },
            icon: "circle",
            right: "0",
            bottom: "10%",
            // padding: [30, 60],
            itemGap: 20,
          },
          toolbox: {
            show: false,
          },
          series: [
            {
              type: "pie",
              clockWise: false,
              radius: ["40%", "54%"],
              center: ["50%", "40%"],
              hoverAnimation: false,
              zlevel: 0,
              label: {
                show: true,
                position: "outside",
                color: "#666",
                formatter: function (params) {
                  if (params.name !== "") {
                    return params.name + " " + params.value;
                  } else {
                    return "";
                  }
                },
              },
              labelLine: {
                //引导线设置
                length: 20,
                show: true, //引导线显示
              },
              data: val,
            },
          ],
        };
        if (this.dom != null && this.dom != "" && this.dom != undefined) {
          this.dom.dispose();
        }
        this.dom = echarts.init(this.$refs.dom);
        this.dom.setOption(option);
        on(window, "resize", this.resize);
      });
    },
  },

  beforeDestroy() {
    off(window, "resize", this.resize);
  },
};
</script>
